export interface AssocBasicInfo {
  name: string;
  shortName: string;
  founded: string;
  description: string;
  mission: string;
  slogan: string;
  phone: string;
  email: string;
  address: string;
  addressProvince: string;
  addressCity: string;
  addressDistrict: string;
  addressDetail: string;
  website: string;
  wechat: string;
  weibo: string;
  douyin: string;
  xiaohongshu: string;
  bilibili: string;
  twitter: string;
  assocType: string;
  certNumber: string;
  coverCity: string;
  memberCount: number;
  logoUrl: string;
  bannerUrl: string;
  /** 入会/续费收款户名 */
  enrollmentPayee: string;
  enrollmentBankName: string;
  enrollmentBankAccount: string;
  /** 转账备注示例；空则前端用默认「姓名 + …」 */
  enrollmentTransferNote: string;
  enrollmentFeeCollectMode: number;
  /** 入会协议 PDF 电子章 */
  enrollmentAgreementSealUrl: string;

  /** 资讯图片上传大小上限（MB）；0=按系统默认 */
  newsImageUploadMaxMb: number;
  /** 资讯视频上传大小上限（MB）；0=按系统默认 */
  newsVideoUploadMaxMb: number;
}

const STORAGE_KEY = "assoc_basic_info_v1";
const listeners = new Set<() => void>();

export const defaultBasicInfo: AssocBasicInfo = {
  name: "",
  shortName: "",
  founded: "",
  description: "",
  mission: "",
  slogan: "",
  phone: "",
  email: "",
  address: "",
  addressProvince: "",
  addressCity: "",
  addressDistrict: "",
  addressDetail: "",
  website: "",
  wechat: "",
  weibo: "",
  douyin: "",
  xiaohongshu: "",
  bilibili: "",
  twitter: "",
  assocType: "球迷协会",
  certNumber: "",
  coverCity: "",
  memberCount: 0,
  logoUrl: "",
  bannerUrl: "",
  enrollmentPayee: "",
  enrollmentBankName: "",
  enrollmentBankAccount: "",
  enrollmentTransferNote: "",
  enrollmentFeeCollectMode: 0,
  enrollmentAgreementSealUrl: "",
  newsImageUploadMaxMb: 0,
  newsVideoUploadMaxMb: 0,
};

function notify() {
  listeners.forEach((fn) => fn());
}

export const basicInfoStore = {
  get(): AssocBasicInfo {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? { ...defaultBasicInfo, ...(JSON.parse(raw) as Partial<AssocBasicInfo>) } : defaultBasicInfo;
    } catch {
      return defaultBasicInfo;
    }
  },

  save(info: AssocBasicInfo) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(info));
    notify();
  },

  subscribe(fn: () => void): () => void {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};
